import {
  SidebarGroupLabel as ShadcnSidebarGroupLabel,
  SidebarMenuButton as ShadcnSidebarMenuButton,
  SidebarMenuSubButton as ShadcnSidebarMenuSubButton,
} from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

export const SidebarGroupLabel = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarGroupLabel>) => (
  <ShadcnSidebarGroupLabel
    className={cn('font-display', className)}
    {...props}
  />
)

export const SidebarMenuButton = ({
  isActive,
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarMenuButton>) => (
  <ShadcnSidebarMenuButton
    isActive={isActive}
    className={cn(
      'transition-colors [&_>_*:not(svg)]:text-muted-foreground hover:[&_>_*:not(svg)]:text-sidebar-accent-foreground',
      isActive &&
        '[&_>_*:not(svg)]:text-sidebar-accent-foreground [&_>_svg]:text-orange-400',
      className
    )}
    {...props}
  />
)

export const SidebarMenuSubButton = ({
  isActive,
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarMenuSubButton>) => (
  <ShadcnSidebarMenuSubButton
    isActive={isActive}
    className={cn(
      'transition-colors [&_>_*:not(svg)]:text-muted-foreground hover:[&_>_*:not(svg)]:text-sidebar-accent-foreground',
      isActive &&
        '[&_>_*:not(svg)]:text-sidebar-accent-foreground [&>svg]:text-orange-400',
      className
    )}
    {...props}
  />
)

export {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupAction,
  SidebarGroupContent,
  SidebarHeader,
  SidebarInput,
  SidebarInset,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuBadge,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarMenuSub,
  SidebarMenuSubItem,
  SidebarProvider,
  SidebarRail,
  SidebarSeparator,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar'
